module.exports = __webpack_public_path__ + "static/media/addtagimg.bbbc5cf9.png";